const MapStyle = (state ='basic', action) => {
    switch(action.type){
        case 'MAP_STYLE':
            return action.payload
    }
    return state;
}

export default MapStyle;


// WEBPACK FOOTER //
// ./src/reducers/mapStyle.js